import { Menu } from "@/models";
import { useRouter } from "next/router";

export function useIsMenuActive(): (menu: Menu) => boolean {
  const { pathname } = useRouter();

  const isMenuActive = (menu: Menu) => {
    if (menu.link && pathname.startsWith(`/${menu.link}`)) {
      return true;
    }

    if (menu.menusFilho?.some(isMenuActive)) {
      return true;
    }

    return false;
  };

  return isMenuActive;
}
